import { Grid, Typography } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import { getData, storeData } from "../../utils/GlobalHelper";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import HeaderPage from "../../components/HeaderPage/Index";
import ScrollBarComponent from "../../components/BoxRightContent/ScrollBarComponent";
import { isMobile } from "react-device-detect";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import RadioComponent from "../../components/ChoiceComponent/RadioComponent";
import DialogWait from "../../components/CustomDialog/DialogWait";
import Loading from "../../components/loading/loading";
import { isEmpty } from "lodash";
import Configs from "../../constants/Configs";
import GlobalApi from "../../utils/GlobalApi";
import { API_CODE_SUCCESS } from "../../constants/CommonConstant";
const useStyle = makeStyles({
  paddingTopBottom: {
    padding: "10px 0",
  },
});

const Suit12 = (props) => {
  const classes = useStyle();
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";
  const [lang, setLang] = useState(getData("lang"));
  const idc = getData("idc");
  const [isLoading, setIsLoading] = useState(false);
  const [translations, setTranslations] = useState("");
  const [isModelWait, setIsModelWait] = useState(false);
  const [productInspec, setProductInspec] = useState([]);
  const [isModelWaitText, setIsModelWaitText] = useState({
    title: "",
    massage: "",
    btn: "",
  });
  const [suitJson, setSuitJson] = useState(getData("suit_json"));
  const chooce = getData("chooce")?.["1"];
  const handleNext = () => {
    checkFlag();
  };

  const PostSuit = async () => {
    setIsLoading(true);
    try {
      let arrayJson = {
        head_token,
        suit_json: [...suitJson],
        answerjson14: [...getData("answerjson14")],
      };
      GlobalApi.post(Configs.baseAPIURL03 + "/form/suitability/manp", arrayJson)
        .then((res) => {
          setIsLoading(false);
          if (res?.status === API_CODE_SUCCESS) {
            if (suitJson.length === 12) {
              chooce.forEach((row, i) => {
                if (i > 11) {
                  suitJson.push({
                    SAfsac_Id: 0,
                    SAfsac_SAmsa_Id: row.SAmsa_Id ? row.SAmsa_Id : "",
                    SAfsac_Answer: row.SAfsac_Answer
                      ? parseInt(row.SAfsac_Answer)
                      : "",
                    SAfsac_Score: row.SAfsac_Score
                      ? parseInt(row.SAfsac_Score)
                      : "",
                    SAfsac_SubId: row.SAfsac_SubId ? row.SAfsac_SubId : "",
                    SAfsac_SubAnswer: row.SAfsac_SubAnswer
                      ? row.SAfsac_SubAnswer
                      : "",
                    SAfsac_Remark: row.SAfsac_Remark ? row.SAfsac_Remark : "",
                    SAfsac_Remark2: row.SAfsac_Remark2
                      ? row.SAfsac_Remark2
                      : "",
                    SAfsac_Delflag: 0,
                  });
                }
              });
              storeData("suit_json", suitJson);
            }
            props.history.push("/suit_15");
          }
        })
        .catch((er) => {
          setIsLoading(false);
          setIsModelWait(true);
        });
    } catch (error) {
      setIsLoading(false);
      setIsModelWait(true);
    }
  };
  const checkFlag = () => {
    if (
      productInspec?.TFEXFlag.toString() === "0" &&
      productInspec?.ForeignFlag.toString() === "0"
    ) {
      PostSuit();
    } else if (
      productInspec?.TFEXFlag.toString() === "1" &&
      productInspec?.ForeignFlag.toString() === "0"
    ) {
      if (suitJson?.[10].SAfsac_Answer.toString() === "3") {
        PostSuit();
      } else {
        setTextFlag(11);
      }
    } else if (
      productInspec?.TFEXFlag.toString() === "0" &&
      productInspec?.ForeignFlag.toString() === "1"
    ) {
      if (suitJson?.[11].SAfsac_Answer.toString() === "3") {
        PostSuit();
      } else {
        setTextFlag(12);
      }
    } else {
      if (
        suitJson?.[10]?.SAfsac_Answer.toString() === "1" &&
        suitJson?.[11]?.SAfsac_Answer.toString() === "3"
      ) {
        setTextFlag(11);
      } else if (
        suitJson?.[10]?.SAfsac_Answer.toString() === "3" &&
        suitJson?.[11]?.SAfsac_Answer.toString() === "1"
      ) {
        setTextFlag(12);
      } else if (suitJson?.[10]?.SAfsac_Answer.toString() === "1") {
        setTextFlag(11);
      } else if (suitJson?.[11]?.SAfsac_Answer.toString() === "1") {
        setTextFlag(12);
      } else {
        PostSuit();
      }
    }
  };
  const setTextFlag = (id) => {
    if (id === 11) {
      setIsModelWaitText({
        title: translations[lang]?.suit?.suit_question_11_no?.title,
        massage: translations[lang]?.suit?.suit_question_11_no?.massage,
        btn: translations[lang]?.suit?.suit_question_11_no?.btn,
      });
    } else if (id === 12) {
      setIsModelWaitText({
        title: translations[lang]?.suit?.suit_question_12_no?.title,
        massage: translations[lang]?.suit?.suit_question_12_no?.massage,
        btn: translations[lang]?.suit?.suit_question_12_no?.btn,
      });
    }
  };
  const apiFlag = async () => {
    setIsLoading(true);
    try {
      const header = {
        headers: {
          Accept: "application/json",
        },
      };
      await GlobalApi.post(
        `${Configs.baseAPIURL03}/form/product_inspec/selbyhead`,
        {
          head_token: head_token,
          id_card: idc?.idCard,
        },
        header,
      )
        .then((res) => {
          setIsLoading(false);
          setProductInspec(res?.data?.Data?.[0]);
        })
        .catch((er) => {
          // console.log(er);
          setIsLoading(false);
          setIsModelWait(true);
        });
    } catch (error) {
      setIsLoading(false);
      setIsModelWait(true);
    }
  };
  useEffect(() => {
    if (!isEmpty(isModelWaitText.title)) setIsModelWait(true);
  }, [isModelWaitText]);
  useEffect(() => {
    apiFlag();
    const translation = getData("Translations");
    if (!isEmpty(translation)) {
      setTranslations(translation);
    } else {
      props.history.push("/");
    }
  }, []);
  return (
    <>
      <HeaderPage
        title={translations?.[lang]?.suit?.title}
        onChangeLang={(e) => setLang(e)}
        clickBack={(e) => (e ? props.history.push("/suit_10") : "")}
      />
      <DialogWait
        open={isModelWait}
        isModel={setIsModelWait}
        title={isModelWaitText.title}
        massage={isModelWaitText.massage}
        btn={isModelWaitText.btn}
      />
      <Loading status={isLoading} />
      <Grid className="background-bg">
        <Grid className="section-consent">
          <Grid className={isMobile ? "box-content-mb" : "box-content"}>
            <Grid container className="box-content-main" columns={16}>
              {!isMobile && (
                <Grid item xs={7} className="box-left">
                  <BoxLeftContent
                    translations={translations?.[lang]?.suit}
                    clickBack={(e) => props.history.push("/suit_10")}
                  />
                </Grid>
              )}
              <Grid
                item
                xs={isMobile ? 16 : 9}
                className={isMobile ? "box-right-mb" : "box-right"}
              >
                <Grid className="content">
                  <Grid className="content-main">
                    <Grid
                      className="box-right-content pb-3"
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                      }}
                    >
                      {" "}
                      <HeaderRight title={translations?.[lang]?.suit?.title} />
                      <ScrollBarComponent
                        content={
                          <>
                            <Grid>
                              <Grid>
                                <Typography className="text-primary font-weight-bold font-20">
                                  {
                                    translations?.[lang]?.suit
                                      ?.suit_question_title_12
                                  }
                                </Typography>
                              </Grid>
                              <Grid
                                className={clsx(
                                  "font-DBHeavent",
                                  "font-18",
                                  classes.paddingTopBottom,
                                )}
                              >
                                {
                                  translations?.[lang]?.suit
                                    ?.suit_question_description_12
                                }
                              </Grid>
                              <Grid>
                                {chooce?.map(
                                  (items, i) =>
                                    i > 9 &&
                                    i < 12 && (
                                      <Grid key={i}>
                                        <Grid
                                          className={clsx(
                                            "font-DBHeavent",
                                            "font-20",
                                            "text-primary",
                                          )}
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              lang === "en"
                                                ? items?.SAmsa_EnQuestion
                                                : items?.SAmsa_Question,
                                          }}
                                        />
                                        <RadioComponent
                                          suitJson={suitJson?.[i]}
                                          choice={
                                            lang === "en"
                                              ? JSON.parse(
                                                  items?.SAmsa_EnAnswer,
                                                )
                                              : JSON.parse(items?.SAmsa_Answer)
                                          }
                                          handleChange={(e) => {
                                            suitJson[i].SAfsac_Answer =
                                              parseInt(e.target.value);
                                            suitJson[i].SAfsac_Score = parseInt(
                                              e.target.value,
                                            );
                                            setSuitJson([...suitJson]);
                                          }}
                                        />
                                      </Grid>
                                    ),
                                )}
                              </Grid>
                            </Grid>
                          </>
                        }
                      />{" "}
                      <ButtonRight
                        isDisbled
                        disbled={
                          suitJson?.[10].SAfsac_Answer !== "" &&
                          suitJson?.[11].SAfsac_Answer !== ""
                        }
                        text={translations?.[lang]?.suit?.next}
                        onNextPage={handleNext}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
export default memo(Suit12);
